import {
	useAppDispatch
} from '../../../../shared/lib/hooks/useAppDispatch/useAppDispatch'
import { KeyboardEvent, useState } from 'react'
import {
	useAppSelector
} from '../../../../shared/lib/hooks/useAppSelector/useAppSelector'
import {
	isExpirationUnlimited,
	LICENSE_UNLIMITED,
	TEXT_UNLIMITED
} from '../../../../entities/License'
import Stack from '@mui/material/Stack'
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers'
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns'
import { Control, Controller } from 'react-hook-form'
import TextField from '@mui/material/TextField'
import Tooltip from '@mui/material/Tooltip'
import Button from '@mui/material/Button'
import { SvgIcon } from '../../../../shared/ui/SvgIcon/SvgIcon'
import { faInfinity } from '@fortawesome/free-solid-svg-icons/faInfinity'
import { appActions, selectAppEditable } from '../../../../entities/Application'
import { SxProps } from '@mui/material'

interface AppExpDateProps {
	control: Control
	styles?: SxProps
}

export const AppExpDate = (props: AppExpDateProps) => {
	const { control, styles } = props
	const dispatch = useAppDispatch()

	const [open, setOpen] = useState(false)
	const { expirationDate } = useAppSelector(selectAppEditable)
	const isUnlimited = isExpirationUnlimited(expirationDate)
	const minDate = new Date(Date.now() + 24 * 60 * 60 * 1000)

	const handleOpen = () => setOpen(true)
	const handleClose = () => setOpen(false)

	const handleDateChange = (newValue: Date | null) => {
		if (newValue) {
			dispatch(appActions.setExpirationDate(newValue))
		}
	}

	const onKeyDown = (e: KeyboardEvent) => {
		e.preventDefault()
	}

	const handleMakeUnlimited = () => {
		dispatch(appActions.setExpirationDate(new Date(LICENSE_UNLIMITED)))
	}

	return (
		<Stack
			direction="row"
			spacing={2}
			alignItems={'baseline'}
			sx={styles}
		>
			<LocalizationProvider dateAdapter={AdapterDateFns}>
				<Controller
					name="expirationDate"
					control={control}
					defaultValue={expirationDate}
					render={({ field }) => {
						return (
							<DatePicker
								open={open}
								onOpen={handleOpen}
								onClose={handleClose}
								disableHighlightToday
								minDate={minDate}
								inputFormat="yyyy-MM-dd"
								label="Application expiration date"
								value={expirationDate || null}
								onChange={(date) => {
									field.onChange(date)
									handleDateChange(date)
								}}
								PopperProps={{
									placement: 'bottom-start'
								}}
								renderInput={(params) => (
									<TextField
										{...params}
										required
										fullWidth
										onKeyDown={onKeyDown}
										onClick={handleOpen}
										InputLabelProps={{ shrink: !!expirationDate }}
										inputProps={{
											...params.inputProps,
											readOnly: true,
											placeholder:
												'Pick application expiration date  \u279C'
										}}
										helperText={isUnlimited && TEXT_UNLIMITED}
									/>
								)}
							/>
						)
					}}
				/>
			</LocalizationProvider>
			<Tooltip title={'Make unlimited'}>
				<Button
					variant="outlined"
					sx={{ px: 0, maxHeight: '2rem', minWidth: '32px' }}
					onClick={handleMakeUnlimited}
				>
					<SvgIcon icon={faInfinity} />
				</Button>
			</Tooltip>
		</Stack>
	)
}